import { AuthUtils } from '@portal/portal-core';
import React from 'react';
import { Provider } from 'react-redux';

import Lockr from 'utils/local-store';
import { StyleSheetManager, ThemeProvider } from 'styled-components';

import { checkClientNetworkPoll, serviceConnectionAlert } from 'components/alert-ui/alert-setup';
import Layout from 'components/layout';
import { shouldForwardProp } from 'styles/sc-config';
import { AgreementActions } from 'ducks/agreements-client';
import { AuthClientUtils } from 'ducks/auth-client';
import { configureStore } from 'store';
import ConditionalFocus from 'styles/conditional-focus';
import GlobalStyles from 'styles/global-styles';
import theme from 'styles/theme';
import { recordActiveUserTimestamps, setProductName } from 'utils';

import { EDITABLE_INPUT_FIELD_ACTIVE } from 'constants/ui';

const store = configureStore();
// @TODO this should be later in the chain of things in the startup script
checkClientNetworkPoll(store);
// @TODO this should be the very first thing that happens on startup, and also should be
// turned into a Saga
AuthClientUtils.clientConfigPoll(store, serviceConnectionAlert);
// @TODO this should be packaged as part of a startup function
recordActiveUserTimestamps();
// @TODO this should happen at the beginning of the startup script
setProductName('Cloud');
// @TODO this should be refactored into Sagas, along with maybe separating the email verification
// from the pure syncPolling
AuthClientUtils.initiateSyncPolling(store);

const jwt = AuthClientUtils.getAuthJwtToken(AuthClientUtils.getAuthTokenKey());

if (jwt) {
  // @TODO this should be turned into a Saga so we're not passing the store
  store.dispatch(
    AgreementActions.clientUserAgreementGet(AuthUtils.getCombinedEulaFilterSettings()),
  );
}

Lockr.prefix = 'portal.';
const clearHangingEditState = (): void => Lockr.rm(EDITABLE_INPUT_FIELD_ACTIVE);

const App = (): React.JSX.Element => {
  clearHangingEditState();

  return (
    <Provider store={store}>
      <StyleSheetManager shouldForwardProp={shouldForwardProp}>
        <ThemeProvider theme={theme}>
          <>
            <GlobalStyles />
            <ConditionalFocus />
            <Layout />
          </>
        </ThemeProvider>
      </StyleSheetManager>
    </Provider>
  );
};

export default App;
